import Typography from "@/src/views/components/Typography";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import Button from "@/src/views/components/Button";
import { useRouter } from "next/router";
import PointLine3 from "@/src/views/components/Icon/icons/PointLine3";
import PointLine4 from "@/src/views/components/Icon/icons/PointLine4";

export default function LandingCallToAction({ callToAction }) {
  const router = useRouter()
  const illustrationRef = useRef(null);
  const titleRef = useRef(null);
  const buttonRef = useRef(null);
  const squareOrange1Ref = useRef(null);
  const squareBlue1Ref = useRef(null);
  const squareOrange2Ref = useRef(null);
  const squareBlue2Ref = useRef(null);
  const pointLine3Ref = useRef(null);
  const pointLine4Ref = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (illustrationRef.current) {
      observer.observe(illustrationRef.current);
    }
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    if (buttonRef.current) {
      observer.observe(buttonRef.current);
    }
    if (squareOrange1Ref.current) {
      observer.observe(squareOrange1Ref.current);
    }
    if (squareBlue1Ref.current) {
      observer.observe(squareBlue1Ref.current);
    }
    if (squareOrange2Ref.current) {
      observer.observe(squareOrange2Ref.current);
    }
    if (squareBlue2Ref.current) {
      observer.observe(squareBlue2Ref.current);
    }
    if (pointLine3Ref.current) {
      observer.observe(pointLine3Ref.current);
    }
    if (pointLine4Ref.current) {
      observer.observe(pointLine4Ref.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    illustrationRef,
    titleRef,
    buttonRef,
    squareOrange1Ref,
    squareBlue1Ref,
    squareOrange2Ref,
    squareBlue2Ref,
    pointLine3Ref,
    pointLine4Ref,
  ]);
  
  return (
    <div className={styles["main-service-section"]}>
      <div
        ref={squareOrange1Ref}
        className={styles["square-orange-1-wrapper"]}
        />
      <div
        ref={squareBlue1Ref}
        className={styles["square-blue-1-wrapper"]}
      />
      <div
        ref={squareOrange2Ref}
        className={styles["square-orange-2-wrapper"]}
      />
      <div
        ref={squareBlue2Ref}
        className={styles["square-blue-2-wrapper"]}
      />
      <PointLine3
        className={styles["point-line-1"]}
        svgRef={pointLine3Ref}
      />
      <PointLine4
        className={styles["point-line-2"]}
        svgRef={pointLine4Ref}
      />
      <img
        ref={illustrationRef}
        className={styles["illustration"]}
        src={`${process.env.NEXT_PUBLIC_IMAGES}/characters-standing-illustration.svg`}
      />
      <div
        ref={titleRef}
        className={styles["main-service-title"]}
      >
        <Typography variant="heading-5-bold" color="black">
          Tertarik Berkolaborasi dengan BRIBrain?
        </Typography>
        <Typography variant="heading-2-medium" color="dark40">
          Silakan isi formulir kolaborasi di bawah ini
        </Typography>
      </div>
      <div
        ref={buttonRef}
        className={styles["button-action"]}
      >
        <Button
          size="action"
          text={callToAction?.find(cta => cta.nama_cta = "formulir").deskripsi_cta}
          onClick={() => router.push(callToAction.find(cta => cta.nama_cta = "formulir").link_cta)}
        />
      </div>
    </div>
  );
}
